import * as React from 'react';
var BodyContext = /*#__PURE__*/React.createContext(null);
export default BodyContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/BodyContext.js
// module id = 185
// module chunks = 0